<form #ingredientForm="ngForm" class="editable-ingredients-container" *ngIf="showForm" [@fadeInAnimation]>
  <div nz-row nzGutter="16" class="mb-xs">
    <div class="mb-xxs" nz-col [nzXs]="24" [nzLg]="24" *ngIf="hasCategoryFilter">
      <div class="input-label-form">Filtro por categoría de alimentos</div>
      <div nz-row [nzGutter]="[0, 7]" class="mb-xs categories-row">
        <div nz-col class="mr-xs" *ngIf="selectedIngredientCategories?.length === 0">
          <button
            nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Seleccionar categoría'" nzPopoverMouseEnterDelay="0.3" nzPopoverPlacement="topLeft"
            (click)="onToggleCategoryIngredientEditMode(true)"
            nz-button
            class="add-category-btn"
            @fadeInAnimation>
            <i nz-icon nzType="plus" nzTheme="outline" style="font-size: 11px;"></i>
          </button>
        </div>
        <div nz-col *ngFor="let category of selectedIngredientCategories; index as i">
          <nz-tag class="tag cursor-pointer" [class.disable-tags]="categoryIngredientMode" nz-popover="" nzPopoverTitle=""
            [nzPopoverContent]="!categoryIngredientMode ? 'Remover categoría' : ''" [style.background-color]="category.color"
            (click)="onRemoveIngredientCategory(category?._id)">
            {{ category.name }}
          </nz-tag>
        </div>
      </div>

      <nz-select
        class="mb-sm"
        #ngTags="ngModel"
        #categoryIngredientSelect
        *ngIf="categoryIngredientMode && ingredientCategories.length> 0"
        nzShowSearch
        [(ngModel)]="selectedIngredientCategoriesIds"
        name="tags"
        nzMode="multiple"
        nzPlaceHolder="Cualquier categoría"
        @fadeInAnimation
        (ngModelChange)="onSelectIngredientCategories($event)"
        (nzOpenChange)="onOpenChangeCategoriesSelect($event)"> <!-- (ngModelChange)="onSelectTags($event)" -->
        <nz-option *ngFor="let category of ingredientCategories" [nzValue]="category?._id" [nzLabel]="category.name"></nz-option>
      </nz-select>
    </div>

    <div class="mb-sm" nz-col [nzXs]="24" *ngIf="hasIngredientName">
      <div class="input-label-form">Ingrediente</div>
      <nz-select
        [required]="true"
        [nzDisabled]="categoryIngredientMode"
        nzShowSearch
        name="ingredientId"
        #ingredientId="ngModel"
        class="select-search-ingredient"
        nzPlaceHolder="Selecciona el ingrediente"
        [(ngModel)]="ingredientEdit.ingredientId"
        [nzOptionHeightPx]="!isLoadingFirstIngredients ? 115 : 80"
        [nzServerSearch]="true"
        [nzOptionOverflowSize]="6"
        [nzDropdownRender]="renderTemplate"
        (ngModelChange)="onChooseIngredient($event)"
        (nzOnSearch)="onSearchIngredient($event)">
        <ng-container *ngIf="!isLoadingFirstIngredients; else loadingFirstIngredients">
          <nz-option nzCustomContent *ngFor="let ingredient of (ingredients$ | async)" [nzValue]="ingredient?._id" [nzLabel]="ingredient?.name">
            <div nz-row nzGutter="16" class="custom-option-row-ingredient">
              <div nz-col [nzXs]="24" class="ingredient-name truncate">
                <p>{{ ingredient.name }}</p>
                <p class="tw-text-3xs tw-text-gray-600">SMAE</p>
              </div>
              <div nz-col [nzXs]="24" class="macronutrients macros-in-select d-flex justify-content-between mb-xxs justify-content-between">
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Calorías</p>
                  <p class="text-info text-bold text-small">{{ ingredient.energy_kcal !== -1 ? ingredient.energy_kcal?.toFixed(2) : 0 }} kcal</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Grasas</p>
                  <p class="text-info text-bold text-small">{{ ingredient.totalFat_g !== -1 ? ingredient.totalFat_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">H.C</p>
                  <p class="text-info text-bold text-small">{{ ingredient.carbohydrate_g !== -1 ? ingredient.carbohydrate_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Proteínas</p>
                  <p class="text-info text-bold text-small">{{ ingredient.protein_g !== -1 ? ingredient.protein_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Fibra</p>
                  <p class="text-info text-bold text-small">{{ ingredient.dietaryFiber_g !== -1 ? ingredient.dietaryFiber_g?.toFixed(2) : 0 }} g</p>
                </div>
              </div>
              <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
            </div>
          </nz-option>
        </ng-container>
        <ng-template #loadingFirstIngredients>
          <nz-option nzCustomContent [nzDisabled]="true">
            <div class="tw-h-4">
              <nz-spin class="mt-xlg mb-xlg"></nz-spin>
            </div>
          </nz-option>
        </ng-template>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-spin class="tw-h-0.5 mt-sm mb-sm" *ngIf="isLoadingIngredients"></nz-spin>
      </ng-template>
      <app-message-field [field]="ingredientId"></app-message-field>
    </div>

    <div class="nutritional-properties-container mb-lg" nz-col nzXs="24" *ngIf="selectedIngredient && hasNutritionalProperties" @fadeInAnimation>
      <div class="macronutrient-main">
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Calorías</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.energy_kcal?.toFixed(2) }} kcal</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Grasas</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.totalFat_g?.toFixed(2) }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">H.C</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.carbohydrate_g?.toFixed(2) }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Proteínas</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.protein_g?.toFixed(2) }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Fibra</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.dietaryFiber_g?.toFixed(2) }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Porción</p>
          <p class="text-info text-bold">{{ ingredientEdit?.nutritionalProperties?.portions?.toFixed(2) }}</p>
        </div>
        <div class="macronutrient" *ngIf="ingredientEdit.measure?._id !== selectedIngredient.unitOfMeasurementId">
          <p class="text-info-bold-xs opacity-70">{{ (selectedIngredient.unitOfMeasurement?.name_es || selectedIngredient.unitOfMeasurement?.name) +
            '(s)' }}</p>
          <p class="text-info text-bold">{{ ingredientEdit.nutritionalProperties?.measurementUnits }}</p>
        </div>
        <div class="macronutrient" *ngIf="ingredientEdit.measure?._id === selectedIngredient.unitOfMeasurement?._id &&
          selectedIngredient.unitOfMeasurement?.symbol_es !== 'g'">
          <p class="text-info-bold-xs opacity-70">Gramo(s)</p>
          <p class="text-info text-bold">{{ ingredientEdit.nutritionalProperties?.grams }}</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Categoría</p>
          <p class="text-info text-bold truncate">{{ ingredientEdit.category?.name }}</p>
        </div>
      </div>
    </div>

    <div class="mb-sm" nz-col [nzXs]="24" [nzLg]="18" *ngIf="selectedIngredient && hasMeasurementUnit" @fadeInAnimation>
      <div class="input-label-form">Unidad de medida</div>
      <nz-select [required]="true" nzShowSearch name="measureId" #measure="ngModel" nzPlaceHolder="Selecciona"
        [(ngModel)]="ingredientEdit.measure._id" (ngModelChange)="onChooseMeasure($event)">
        <nz-option *ngFor="let measureUnit of measureUnits | filterMeasurementUnits:selectedIngredient?.unitOfMeasurementId"
          [nzValue]="measureUnit?._id" [nzLabel]="ingredientEdit.units === 1 ? measureUnit.name_es : measureUnit.namePlural_es"></nz-option>
      </nz-select>
      <app-message-field [field]="measure"></app-message-field>
    </div>

    <div class="mb-sm" nz-col [nzXs]="24" [nzLg]="6" *ngIf="selectedIngredient && hasUnits" @fadeInAnimation>
      <div class="input-label-form">Cantidad</div>
      <input [required]="true" name="units" nz-input type="number" min="0" step="1" #units="ngModel" placeholder="Cantidad"
        [(ngModel)]="ingredientEdit.units" (change)="onChangeUnits($event.target.value)" (keyup)="onChangeUnits($event.target.value)" />
      <app-message-field [field]="units"></app-message-field>
    </div>

    <div *ngIf="this.ingredientEdit.isAllergic" class="tw-bg-red-50 tw-rounded tw-text-red-500 tw-p-4 tw-w-full">
      <p>¡Cuidado! Hemos detectado que el paciente es alérgico a este alimento.</p>
    </div>

    <div *ngIf="this.ingredientEdit.isDislike" class="tw-bg-orange-50 tw-rounded tw-text-orange-500 tw-p-4 tw-w-full mt-sm">
      <p>Hemos detectado que al paciente no le gusta este alimento.</p>
    </div>
  </div>

  <div nz-row nzGutter="16" nzJustify="end" *ngIf="hasActionButtons">
    <div nz-col>
      <button type="button" nz-button nzType="default" class="btn-default mr-sm" (click)="onCancelEditIngredient()">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        Cancelar
      </button>
      <button type="button" nz-button nzType="primary" (click)="onAddIngredient()" *ngIf="!isIngredientEdition">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        Agregar</button>
      <button type="button" nz-button nzType="primary" (click)="onModifyIngredient()" *ngIf="isIngredientEdition">
        <i nz-icon nzType="edit" nzTheme="outline"></i>
        Modificar</button>
    </div>
  </div >

  <nz-divider></nz-divider>

</form>
